export function reorderItem(array, sourceIndex, destIndex) {
    if (sourceIndex === destIndex) {
        return array;
    }
    const items = [...array];
    const [reorderedItem] = items.splice(sourceIndex, 1);
    items.splice(destIndex, 0, reorderedItem);
    return items;
}
export function deleteItem(array, targetIndex) {
    const items = [...array];
    items.splice(targetIndex, 1);
    return items;
}
export function updateItem(array, targetIndex, updatedItem) {
    const items = [...array];
    items.splice(targetIndex, 1, updatedItem);
    return items;
}
// Checks if all values are included in array - returns boolean
export function includesAll(array, values) {
    return values.every((v) => array.includes(v));
}
//# sourceMappingURL=array.js.map